// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const CcVisa: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 38 38"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path d="M36.7 7H1.3C.6 7 0 7.6 0 8.3v21.2c0 .7.6 1.3 1.3 1.3h35.5c.7 0 1.3-.6 1.3-1.3V8.3C38 7.6 37.4 7 36.7 7zM11.2 22.5l-1.6-6.2-.1-.1s-.1 0-.1-.1c-.1 0-.1-.1-.2-.1 0 0-.1 0-.1-.1-.1.1-.1.1-.1 0h-.4c-.1 0-.1 0-.2-.1h-.9v-.1h2.9c.8 0 .9.6.9.6l.6 3.2.2 1.1 1.8-4.9h2l-3 7.1-1.7-.3zm4.4 0l1.2-7.1h1.9l-1.2 7.1h-1.9zm5.1.1c-1.3 0-2.1-.4-2.1-.4l.3-1.6c.8.6 3.1.8 3.1-.2s-2.6-1-2.6-2.8c0-2 2.2-2.4 3.1-2.4.9 0 1.7.3 1.7.3l-.3 1.5c-.8-.4-2.6-.5-2.6.3s2.6 1 2.6 2.8c0 1.8-1.9 2.5-3.2 2.5zm8-.1l-.2-1.1h-2.4l-.4 1.1h-1.9l2.8-6.6s.2-.5.9-.5H29l1.5 7.1h-1.8z"/><path d="M26.6 19.9h1.6l-.6-2.6z"/></svg>;
};

export default React.memo(CcVisa);
